module.exports = __webpack_public_path__ + "static/img/grow4.e2b6f6dc.png";